import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BudgetRequestTypeEnum } from '@zaoblako/shared/modules/task/enum/budget-request-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BudgetRequestTypeEnum} enumeration values */
export const BudgetRequestTypeEnumI18n: EnumI18nInterface<BudgetRequestTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BudgetRequestTypeEnum.PLAN]: 'План',
    [BudgetRequestTypeEnum.TRANSFER_EXPENSE_BALANCES]: 'Перенос бюджетных остатков',
    [BudgetRequestTypeEnum.ADJUSTMENT]: 'Корректировка плана',
  },
  [I18nLocalesEnum.EN_US]: {
    [BudgetRequestTypeEnum.PLAN]: 'Plan',
    [BudgetRequestTypeEnum.TRANSFER_EXPENSE_BALANCES]: 'Transfer Expense Balances',
    [BudgetRequestTypeEnum.ADJUSTMENT]: 'Adjusting the plan',
  },
};
